import React, { Component } from 'react'

import { BrowserRouter, Route } from 'react-router-dom'

import SignUpPage from './SignUpPage'
import SignInPage from './SignInPage'
import ResetPasswordPage from './ResetPasswordPage'
import HomePage from './HomePage'
import EditorPage from './EditorPage'
import * as ROUTES from '../constants/routes'
import { withAuthentication } from './Session'
import { withFirebase } from '../Firebase'

class App extends Component {
  signOut = () => {
    this.props.firebase.signOut()
  }

  render() {
    return (
      <BrowserRouter>
        <div>
          <Route exact path={ROUTES.SIGN_IN} component={SignInPage} />
          <Route path={ROUTES.SIGN_UP} component={SignUpPage} />
          <Route path={ROUTES.RESET_PASSWORD} component={ResetPasswordPage} />
          <Route path={ROUTES.EDITOR} component={EditorPage} />
          <Route
            path={ROUTES.HOME}
            render={(props) => (
              <HomePage {...props} onClickSignOut={this.signOut} />
            )}
          />
        </div>
      </BrowserRouter>
    )
  }
}

export default withAuthentication(withFirebase(App))
